module.exports = __webpack_public_path__ + "static/katie-Normal-15a259cafa113c86c8a0c85dfc3ecbe8.jpg";